import { ReviewListRequest, PaginatedReviewPublic } from '@/api'
import { reviewApi } from './review'
import { handleApiError } from '@/lib/api'
import { removeUndefined } from '@/lib/object'
import { REVALIDATE } from '@/constants/constants'

export const getReviewList = async (
  requestParameters: ReviewListRequest,
): Promise<PaginatedReviewPublic> => {
  const params = REVALIDATE
  const response = await reviewApi
    .reviewList({ ...requestParameters }, params)
    .catch(handleApiError)

  if (response === undefined) {
    throw `"response" is undefined for request "reviewList()"`
  }

  if (response.body == null) {
    throw `"response.body" is ${response.body} for request "reviewList()"`
  }

  return removeUndefined(response.body)
}
